import { render } from "./ViewMyAccount.vue?vue&type=template&id=78a6ab80&scoped=true&ts=true"
import script from "./ViewMyAccount.vue?vue&type=script&lang=ts"
export * from "./ViewMyAccount.vue?vue&type=script&lang=ts"

import "./ViewMyAccount.vue?vue&type=style&index=0&id=78a6ab80&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a6ab80"]])

export default __exports__